module.exports = __webpack_public_path__ + "img/wisdom_4.082562c7.svg";